export default __webpack_public_path__ + "static/media/shield.33a3a0fc.svg";